export default __webpack_public_path__ + "static/media/img-service.ccd3a659.png";